import EditorToolbar from './EditorToolbar';
export default EditorToolbar;
//# sourceMappingURL=index.js.mapimport EditorToolbar from './EditorToolbar';
export default EditorToolbar;
//# sourceMappingURL=index.js.map